const NotFound = () => (
  <div className="not-found-container">
    <h1 style={{textAlign: 'center'}}>Page Not Found</h1>
  </div>
);

export default NotFound;
